<div class="multiple-rows-wrapper" [class]="wrapperClass">
  @for (row of strings; track row) {
    <div class="string-row" [class]="rowClass">{{ row }}</div>
  }
</div>
